// Aile hitabi varyantlari (Noel serisi 5. bolum): "mama" Etsy'nin en cok
// satan kelimelerinden; ayni urunun grandma / nana / gigi / auntie halleri ayri
// arama kitleleri. Satan listedeki hitap kelimesi bulunur, ailedeki diger
// kelimelerle yeni liste/tasarim fikri uretilir. Christmas'ta en cok satan
// kisisellestirilmis aile hediyeleri; aunt/auntie takida neredeyse bos.

export const FAMILY_GROUPS: Array<{ key: string; label: string; words: string[] }> = [
  { key: "mom", label: "Anne", words: ["Mama", "Mom", "Mommy", "Mum", "Mother"] },
  { key: "grandma", label: "Büyükanne", words: ["Grandma", "Nana", "Gigi", "Mimi", "Granny", "Nonna", "Oma", "Grammy", "Mamaw", "Glamma"] },
  { key: "aunt", label: "Teyze/hala", words: ["Aunt", "Auntie", "Aunty", "Tia", "Titi"] },
  { key: "dad", label: "Baba", words: ["Dad", "Daddy", "Papa", "Father"] },
  { key: "grandpa", label: "Büyükbaba", words: ["Grandpa", "Papa", "Pops", "Grandad", "Poppy"] },
  { key: "sister", label: "Kız kardeş", words: ["Sister", "Sis", "Big Sister", "Little Sister"] },
];

/** Bir aile grubundan digerine gecis onerileri (mama satiyorsa grandma ve aunt da dene) */
const CROSS: Record<string, string[]> = {
  mom: ["grandma", "aunt"],
  grandma: ["mom", "aunt"],
  aunt: ["grandma", "sister"],
  dad: ["grandpa"],
  grandpa: ["dad"],
  sister: ["aunt"],
};

export interface FamilyVariant { group: string; word: string; title: string }

const esc = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

/** Basliktaki ilk aile kelimesini bulur; ayni ve yakin gruplardaki kelimelerle
 *  degistirilmis baslik onerileri dondurur. Bulunamazsa bos. */
export function familyVariants(title: string): { found: string | null; variants: FamilyVariant[]; grandkidsIdea: boolean } {
  const t = title ?? "";
  // Basliktaki EN ONCE gecen aile kelimesi grubu belirler (esitlikte uzun ifade: "Big Sister" > "Sister")
  let hit: { g: string; w: string; at: number } | null = null;
  for (const g of FAMILY_GROUPS) for (const w of g.words) {
    const m = new RegExp(`\\b${esc(w)}\\b`, "i").exec(t);
    if (m && (!hit || m.index < hit.at || (m.index === hit.at && w.length > hit.w.length))) hit = { g: g.key, w, at: m.index };
  }
  if (!hit) return { found: null, variants: [], grandkidsIdea: false };
  // O gruptaki TUM kelimeler degistirilir ("Mom ... Mama Gift" ikisi birden)
  const own = FAMILY_GROUPS.find((x) => x.key === hit!.g)!.words.slice().sort((a, b) => b.length - a.length);
  const ownRe = new RegExp(`\\b(${own.map(esc).join("|")})\\b`, "gi");
  const groups = [hit.g, ...(CROSS[hit.g] ?? [])];
  const seen = new Set<string>([hit.w.toLowerCase()]);
  const variants: FamilyVariant[] = [];
  for (const gk of groups) {
    const g = FAMILY_GROUPS.find((x) => x.key === gk)!;
    for (const w of g.words) {
      if (seen.has(w.toLowerCase())) continue;
      seen.add(w.toLowerCase());
      variants.push({ group: g.label, word: w, title: t.replace(ownRe, w) });
    }
  }
  // "Cocuk isimli kalp kolye (mom)" -> "grandma + torun isimleri" kalibi
  const grandkidsIdea = hit.g === "mom" && /\b(kids?|children|names?)\b/i.test(t);
  return { found: hit.w, variants, grandkidsIdea };
}
